import React, { useContext } from 'react'
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import { Link, useNavigate } from 'react-router-dom'

import CustomInput from '../widgets/CustomInput' // Custom input component
import CustomBtn from '../widgets/CustomBtn' // Custom button component

import logoImg from '../../assets/images/lociLogo.png'

import { forgotPassword } from '../_slice/onboardingSlice'
import AppContext from '../context/AppContext'

// ForgotPassword component for handling forgotten passwords
function ForgotPassword() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { setLoader } = useContext(AppContext)

  // validation for form control and handle onchange or values
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onChange', // Validate on change event
    defaultValues: {
      email: ''
    }
  })

  /**
   * Handle form submission.
   * @param {Object} data - Form data containing first_name, last_name, email, password, phone, and organisation.
   * @returns {Promise<void>}
   */
  const onSubmit = data => {
    dispatch(
      forgotPassword({
        initialPost: data,
        navigate,
        navigatePath: '/verification',
        state: { email: data.email, type: 'forgot' },
        setLoader
      })
    )
  }
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className='onboarding-box'>
        <div className='onboarding-box-header'>
          <img src={logoImg} alt='' className='onboarding-box-header-img' />
          <p className='onboarding-box-header-text'>The Evolution of Safety.</p>
        </div>
        <h2 className='onboardHeading'>FORGOT PASSWORD?</h2>
        <div className='mb-4'>
          <CustomInput
            label='Email'
            type='email'
            classname='custom_input'
            tabIndex='1'
            // maxlength={65} // Maximum length of email input
            {...register('email', {
              required: 'Email required',
              pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i,
                message: 'Invalid email address'
              }
            })}
          />
          {errors.email && (
            <p className='text-danger'>{errors.email.message}</p>
          )}
        </div>

        {/* Footer section */}
        <div className='onboarding-box-footer justify-content-between'>
          <Link to='/' className='onboarding-box-footer-text'>Login</Link>
          <CustomBtn buttonText='Next' type='submit' id='forgotbtn' />
        </div>

      </div>
    </form>
  )
}

export default ForgotPassword